"use client";

import { useRevealOnScroll } from "@/hooks/useRevealOnScroll";
export default function MeetNikiB() {
  const {
    ref: leftRef,
    isVisible: leftVisible
  } = useRevealOnScroll<HTMLDivElement>({
    threshold: 0.15
  });
  const {
    ref: rightRef,
    isVisible: rightVisible
  } = useRevealOnScroll<HTMLDivElement>({
    threshold: 0.15
  });
  return <section data-section-id="2176" id="meet-niki-b" className="bg-background text-foreground relative min-h-screen w-full overflow-hidden">
      <div className="grid grid-cols-1 lg:grid-cols-2 min-h-screen">
        {}
        <div ref={leftRef} className={`relative bg-background text-foreground flex items-center px-8 sm:px-12 lg:px-20 py-20 lg:py-24 transition-all duration-1000 ease-out ${leftVisible ? "opacity-100 translate-y-0" : "opacity-0 translate-y-6"}`}>
          <div className="max-w-xl w-full">
            {}
            <div className="mb-10 lg:mb-14 flex items-center gap-3">
              <span className="block h-px w-10 bg-primary" />
              <span className="font-mono text-[11px] tracking-[0.25em] uppercase text-primary">
                Capítulo Uno &middot; La Artista
              </span>
            </div>

            {}
            <h2 className="font-default font-light text-[44px] sm:text-5xl lg:text-[64px] leading-[1.02] tracking-tight text-foreground">
              Belleza definida por
              <br />
              el <em className="italic font-light text-primary">sutil</em> arte
              <br />
              del refinamiento.
            </h2>

            {}
            <div className="mt-10 mb-8 h-px w-24 bg-primary" />

            {}
            <div className="space-y-5 text-[16px] leading-[1.7] font-default text-muted-foreground">
              <p>Nicole Barrios comenzó como una visionaria para elevar la estética de la belleza. Con base entre Valencia y Madrid, su trabajo se centra en el enfoque editorial de la belleza, asegurando que cada cliente se sienta como la versión más pulida de sí mismo.</p>
              <p>Ella cree que el verdadero arte reside en los detalles. Desde sesiones con modelos profesionales hasta estilismo nupcial a medida, su trabajo se define por líneas limpias, texturas naturales y un compromiso con la elegancia atemporal.</p>
            </div>

            {}
            <div className="mt-12 flex flex-col">
              <span className="font-default italic text-2xl text-foreground">Nicole Barrios.</span>
              <span className="mt-1 font-mono text-[10px] tracking-[0.3em] uppercase text-muted-foreground">
                Fundadora &middot; Artista Principal
              </span>
              <svg className="mt-3 h-6 w-32 text-foreground" viewBox="0 0 160 24" fill="none" xmlns="http://www.w3.org/2000/svg" aria-hidden="true">
                <path d="M2 16 C 14 4, 26 22, 38 12 S 62 2, 76 14 S 102 22, 118 10 S 146 18, 158 8" stroke="currentColor" strokeWidth="1.2" strokeLinecap="round" fill="none" />
                <path d="M40 18 C 48 14, 56 20, 64 16" stroke="currentColor" strokeWidth="0.8" strokeLinecap="round" fill="none" opacity="0.6" />
              </svg>
            </div>
          </div>
        </div>

        {}
        <div ref={rightRef} className={`relative bg-card flex items-stretch p-6 sm:p-10 lg:p-12 transition-all duration-1000 ease-out ${rightVisible ? "opacity-100 translate-y-0" : "opacity-0 translate-y-6"}`}>
          <div className="relative w-full overflow-hidden rounded-lg">
            <img src="https://wpvc-images.s3.us-east-1.amazonaws.com/images/1699048/img/niki_b_signature_look.png" data-wvc-srcset="https://wpvc-images.s3.us-east-1.amazonaws.com/images/1699048/img/niki_b_signature_look.png-wvc-srcset" data-wvc-sizes="https://wpvc-images.s3.us-east-1.amazonaws.com/images/1699048/img/niki_b_signature_look.png-wvc-sizes" alt="Editorial makeup look by Niki B. featuring natural skin texture and refined highlights" loading="lazy" decoding="async" className="h-full w-full object-cover min-h-[480px] lg:min-h-0" src="https://wpvc-images.s3.us-east-1.amazonaws.com/images/1699048/img/Screenshot-2026-06-09-151903.webp" src="https://wpvc-images.s3.us-east-1.amazonaws.com/images/1699048/img/Screenshot-2026-06-11-115019.webp" src="https://wpvc-images.s3.us-east-1.amazonaws.com/images/1699048/img/Screenshot-2026-06-11-115019.webp" src="https://wpvc-images.s3.us-east-1.amazonaws.com/images/1699048/img/Screenshot-2026-06-11-115019.webp" src="https://wpvc-images.s3.us-east-1.amazonaws.com/images/1699048/img/Screenshot-2026-06-11-115019.webp" src="https://nikibmakeup.com/wp-content/uploads/2026/06/Screenshot-2026-06-11-115019.png" />

            {}
            <div className="pointer-events-none absolute inset-0 bg-gradient-to-t from-foreground/60 via-transparent to-foreground/20" />

            {}
            <div className="absolute bottom-6 left-6 sm:bottom-8 sm:left-8 bg-background text-foreground px-5 py-3 rounded-lg shadow-md">
              <div className="flex items-center gap-3">
                <span className="block h-px w-5 bg-primary" />
                <span className="font-default italic text-sm tracking-wide">
                  Valencia y Madrid &middot; Con Cita Previa
                </span>
              </div>
            </div>
          </div>
        </div>
      </div>

      {}
      <div className="hidden lg:flex absolute top-0 bottom-0 left-1/2 -translate-x-1/2 flex-col items-center justify-center pointer-events-none" aria-hidden="true">
        <div className="flex-1 w-px bg-gradient-to-b from-transparent via-primary/60 to-primary/40" />
        <div className="my-4 flex items-center justify-center w-8 h-8 rounded-lg bg-background shadow-md">
          <svg viewBox="0 0 24 24" className="h-4 w-4 text-primary" fill="none" xmlns="http://www.w3.org/2000/svg">
            <path d="M12 3 C 14 7, 14 9, 12 12 C 10 9, 10 7, 12 3 Z" fill="currentColor" opacity="0.9" />
            <path d="M12 21 C 14 17, 14 15, 12 12 C 10 15, 10 17, 12 21 Z" fill="currentColor" opacity="0.9" />
            <path d="M3 12 C 7 10, 9 10, 12 12 C 9 14, 7 14, 3 12 Z" fill="currentColor" opacity="0.7" />
            <path d="M21 12 C 17 10, 15 10, 12 12 C 15 14, 17 14, 21 12 Z" fill="currentColor" opacity="0.7" />
            <circle cx="12" cy="12" r="1.4" fill="currentColor" />
          </svg>
        </div>
        <div className="flex-1 w-px bg-gradient-to-t from-transparent via-primary/60 to-primary/40" />
      </div>
    </section>;
}